import type { SimpleChanges } from '@angular/core';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';

import type { GetInputs } from '@core/common-legacy';
import { componentOutletConfigFactory, TimeService } from '@core/common-legacy';
import type { JobSchedulerData } from '@core/offers-types';
import { JobSchedulerErrorComponent } from '@core/offers-ui';
import type { DataTableRow, TableCellFactory } from '@core/user-interface-legacy';
import { EMPTY_CELL, RtTooltip, TABLE_CELL_TIME_FORMAT } from '@core/user-interface-legacy';

/*
 eslint-disable
 @typescript-eslint/consistent-type-assertions,
 @angular-eslint/no-inputs-metadata-property,
*/

@Component({
  imports: [RtTooltip, JobSchedulerErrorComponent],
  template: `
    @if (!jobScheduler?.error) {
      <div [rtTooltip]="$safeNavigationMigration(jobScheduler?.timezone)">
        {{ date }}
      </div>
    } @else {
      <rt-job-scheduler-error [schedulerError]="$safeNavigationMigration(jobScheduler?.error)" />
    }
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  inputs: ScheduleCellComponent.NgInputs,
})
export class ScheduleCellComponent {
  public static NgInputs = ['jobScheduler' as const, 'dateKey' as const];

  public jobScheduler: JobSchedulerData | null;
  public dateKey: 'publishDate' | 'closeDate';
  public date: string;

  private timeService = inject(TimeService);

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.jobScheduler) {
      this.date = this.timeService.format({
        input: this.jobScheduler?.[this.dateKey],
        pattern: TABLE_CELL_TIME_FORMAT,
      });
    }
  }
}

export const scheduleCellFactory =
  <Key extends keyof Row, Row extends DataTableRow & { [k in Key]: JobSchedulerData }>(
    key: Key,
    dateKey: GetInputs<typeof ScheduleCellComponent>['dateKey'],
  ): TableCellFactory<Row> =>
  ({ row }) => {
    if (!row[key]?.[dateKey]) return EMPTY_CELL;

    return componentOutletConfigFactory(ScheduleCellComponent, {
      inputs: { jobScheduler: row[key], dateKey },
    });
  };
